<template>
    <div class="or-admin-product-card">
        <or-admin-product-card-title :title="options.title.value.slice(0,40)" @remove="$emit('remove')" @selected="$emit('selected')" @show-edit="show_edit = true" @hide-edit="show_edit = false"/>
        <div v-show="show_edit">
            <or-admin-textarea class="item nesting-main" :options="options.title" @unsaved="$emit('unsaved')"/>
            <or-admin-textarea class="item nesting-main" :options="options.description" @unsaved="$emit('unsaved')"/>
            <or-admin-image-loader class="item nesting-main" :options="options" @unsaved="$emit('unsaved')"/>
            <div class="product-select nesting-main flex-column">
                <p class="select-p">Категория изделия на странице "Продукция"</p>
                <select class="select" v-model="options.production_category_name" @change="selectIdByName('production')">
                    <option v-for="(option, i) in options.production_categories" :key="i">{{option.name}}</option>
                </select>
                <p class="select-p">Отрасли к которым относится изделие:</p>
                <div class="checkbox-container flex-row" v-for="(category, i) in options.buyers_categories" :key="category[i]">
                    <p class="checkbox-p">{{category.name}}</p>
                    <input type="checkbox" @change="changeCategory(category.name)" :checked="options.buyers_category_id !== null && options.buyers_category_id.includes(category.id)"/>
                </div>
                <!-- <select class="select" v-model="options.buyers_category_name" @change="selectIdByName('buyers')">
                    <option v-for="(option, i) in options.buyers_categories" :key="i">{{option.name}}</option>
                </select> -->
            </div>
        </div>
    </div>
</template>

<script>
import orAdminProductCardTitle from "./or-admin-product-card-title.vue"
import orAdminTextarea from "./or-admin-textarea.vue"
import orAdminImageLoader from "./or-admin-image-loader.vue"
export default {
    components: {
        orAdminProductCardTitle,
        orAdminTextarea,
        orAdminImageLoader
    },
    props: {
        options: Object,
    },
    data() {
        return {
            show_edit: false,
            buyers: {},
        }
    },
    methods: {
        selectIdByName(select) {
            if (select === 'production') {
                const name = this.options.production_category_name;
                for (const key in this.options.production_categories) {
                    if (this.options.production_categories[key].name === name) {
                        this.options.production_category_id = this.options.production_categories[key].id;
                    }
                }
            } else {
                const name = this.options.buyers_category_name;
                for (const key in this.options.buyers_categories) {
                    if (this.options.buyers_categories[key].name === name) {
                        this.options.buyers_category_id = this.options.buyers_categories[key].id;
                    }
                }
            }
        },
        changeCategory(name) {
            if (!Array.isArray(this.options.buyers_category_id)) {
                this.options.buyers_category_id = [];
            }
            for (const key in this.options.buyers_categories) {
                if (this.options.buyers_categories[key].name === name) {
                    if (this.options.buyers_category_id.includes(this.options.buyers_categories[key].id)) {
                        this.options.buyers_category_id.splice(this.options.buyers_category_id.indexOf(this.options.buyers_categories[key].id), 1);
                    } else {
                        this.options.buyers_category_id.push(this.options.buyers_categories[key].id);
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
    .item {
        margin-top: 20px;
    }
    .select-p {
        font-size: 14px;
        line-height: 16px;
        margin-left: 20px;
        margin-bottom: 20px;
        text-align: left;
    }
    .select-p:last-of-type {
        margin-top: 20px;
    }
    .select {
        font-size: 14px;
        line-height: 16px;
        height: 50px;
        padding: 17px 16px 14px;
        box-sizing: border-box;
        border-radius: 8px;
        outline: none;
        border: 1px solid #979797;
    }
    .checkbox-container {
        margin-left: 20px;
    }
    .checkbox-p {
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        margin-bottom: 15px;
        margin-right: 20px;
    }
</style>